var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C12.4186 0 16 3.58141 16 8C16 12.4186 12.4186 16 8 16C3.58141 16 0 12.4186 0 8C0 3.58141 3.58141 0 8 0Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3968 8L4.40256 10.1154L6.2 11.1731V12.4115L3.35064 10.7404V7.38141L4.3968 8ZM4.3968 5.88462V7.11731L3.35 6.49808V5.26538L4.3968 4.64615L5.44872 5.26538L4.3968 5.88462ZM6.95064 5.26538L7.99744 4.64615L9.04936 5.26538L7.99744 5.88462L6.95064 5.26538Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15321 9.67692V8.43846L6.2 9.05769V10.2904L5.15321 9.67692ZM6.95064 11.6167L7.99744 12.2359L9.04936 11.6167V12.8494L7.99744 13.4686L6.95064 12.8494V11.6167ZM10.5506 5.26538L11.5974 4.64615L12.6494 5.26538V6.49808L11.5974 7.11731V5.88462L10.5506 5.26538ZM11.5974 10.1154L11.6032 8L12.65 7.38077V10.7397L9.80064 12.4109V11.1724L11.5974 10.1154Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8468 9.67692L9.8 10.2904V9.05769L10.8468 8.43846V9.67692Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8468 6.32308L10.8526 7.56154L9.05 8.61923V10.7397L8.00321 11.3532L6.95641 10.7397V8.61923L5.15385 7.56154V6.32308L6.20513 5.70385L7.99679 6.76667L9.79936 5.70385L10.8513 6.32308H10.8468ZM5.15321 4.20833L7.99744 2.53141L10.8468 4.20833L9.8 4.82756L7.99744 3.76474L6.2 4.82756L5.15321 4.20833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.1b12bf8b5abbcaee90874a3cfb199828.svg";
export { ForwardRef as ReactComponent };